import {
  faChevronLeft,
  faChevronRight,
  faHouseUser,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  addDays,
  format,
  addMonths,
  startOfMonth,
  addWeeks,
  startOfWeek,
  startOfToday,
  isBefore,
} from "date-fns"
import React from "react"
import styled from "styled-components"
import { MButton } from "../../../components/MButton"

import { DowUtils } from "../../../utils/dowUtils"
import { useVenueAvailableSlots } from "../../calendar/api/useVenueAvailableSlots"
import { useReservationContext } from "../reservationContext"
import { VenueSectionProducts } from "../../miejsca/widgets/VenueSectionProducts"
import { LoadingWidget } from "../../../components/LoadingWidget"

const TimeSlotSectionStyled = styled.div`
  padding: 16px;
  .dayParts {
    display: flex;
    flex-direction: row;
    .dayPart {
      padding: 16px;
      flex: 1;
      text-align: center;
    }
  }

  .timeSlots {
    display: flex;
    flex-direction: row;

    .timeSlotsColumn {
      flex: 1;
      text-align: center;
      align-items: center;
      display: flex;
      flex-direction: column;

      .timeSlot {
        width: 300px;
        text-align: center;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 4px 0;
        font-size: 0.8rem;
        cursor: pointer;
        color: white;
        font-weight: 300px;
        font-size: 12px;
        display: flex;
        flex-direction: row;
        &:hover {
          background-color: #eee;
        }
        position: relative;
      }
      .timeSlot.selected {
        background-color: var(--moje-color-pink) !important;
      }
    }
  }
  @media (max-width: 600px) {
    .timeSlot {
      min-width: 200px !important;
    }
  }
`

const VenueSectionStyled = styled.div`
  padding: 16px 32px;
  display: flex;
  flex-direction: row;

  .name {
    flex: 1;
  }
  .product {
    border-left: 1px solid #ddd;
    padding-left: 32px;
    flex: 1;
  }
`

const FooterSectionStyled = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
`

const MonthSelection = ({ selectedMonth, onMonthSelected }) => {
  var months: any = []
  var m = new Date(selectedMonth)
  months.push(addMonths(m, -1))
  months.push(m)
  months.push(addMonths(m, 1))

  return (
    <div className="mb-2 flex items-center">
      <div
        className="w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-gray-300"
        onClick={() => {
          onMonthSelected(format(addMonths(m, -1), "yyyy-MM-dd"))
        }}
      >
        <FontAwesomeIcon icon={faChevronLeft} style={{ width: 16 }} />
      </div>
      <div className="flex flex-auto">
        {months.map((month) => {
          const formatted = format(month, "MMMM")
          return (
            <div
              onClick={() => onMonthSelected(format(month, "yyyy-MM-dd"))}
              className="w-full text-center"
              key={formatted}
            >
              {formatted}
            </div>
          )
        })}
      </div>
      <div
        className="w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-gray-300"
        onClick={() => {
          onMonthSelected(format(addMonths(m, 1), "yyyy-MM-dd"))
        }}
      >
        <FontAwesomeIcon icon={faChevronRight} style={{ width: 16 }} />
      </div>
    </div>
  )
}

const DateSection = ({ selectedDate, onDateSelected, weeksData }) => {
  const dows = []

  for (let i = 0; i < 7; i++) {
    dows.push(DowUtils.getShortDowName(i))
  }

  const color = "var(--moje-color-green)"
  const selectedColor = "var(--moje-color-pink)"
  return (
    <div className="grid grid-cols-7 border-r border-b text-center justify-items-center items-center">
      {dows.map((dow) => (
        <div className="uppercase" key={dow}>
          {dow}
        </div>
      ))}
      {weeksData.map((week) => {
        const days = []
        for (let i = 0; i < 7; i++) {
          days.push(addDays(week.startDate, i))
        }
        return days.map((date) => {
          const pastDate = isBefore(date, startOfToday())
          const isSelected = selectedDate === format(date, "yyyy-MM-dd")
          return (
            <div
              className="m-1 w-7 h-7 sm:w-8 sm:h-8 rounded-full
              cursor-pointer flex items-center justify-center
              text-sm font-light
              transition-colors	duration-150
              text-white hover:text-gray-200
              border hover:border-gray-400"
              onClick={() =>
                !pastDate && onDateSelected(format(date, "yyyy-MM-dd"))
              }
              key={date.getTime()}
              style={{
                backgroundColor: isSelected ? selectedColor : color,
                border: isSelected ? `3px solid ${selectedColor}` : null,
                opacity: pastDate ? 0.5 : null,
              }}
            >
              {date.getDate()}
            </div>
          )
        })
      })}
    </div>
  )
}

const TimeSlotsSection = ({
  availableSlots,
  selectedDate,
  onTimeSlotSelected,
  selectedTimeSlot,
}) => {
  function renderTimeSlotsColumn(fromHour, tillHour) {
    const timeSlotsForDate =
      availableSlots && availableSlots.availableSlots
        ? availableSlots.availableSlots.find((day) => day.date == selectedDate)
        : undefined
    const slotsWithinRange =
      timeSlotsForDate && timeSlotsForDate.timeSlots
        ? timeSlotsForDate.timeSlots.filter((slot) => {
            var start = new Number(slot.from.split(":")[0])
            return start >= fromHour && start <= tillHour
          })
        : []

    var color = "var(--moje-color-green)"
    return (
      <div className="timeSlotsColumn">
        {slotsWithinRange.map((slot) => {
          return (
            <div
              className={`h-7 sm:h-8 timeSlot ${
                selectedTimeSlot && selectedTimeSlot.from == slot.from
                  ? "selected"
                  : ""
              }`}
              style={{ backgroundColor: color }}
              onClick={() => {
                onTimeSlotSelected(slot)
              }}
            >
              {slot.from}
              {" - "} {slot.till}
              {/* <div className="selector"></div> */}
            </div>
          )
        })}
      </div>
    )
  }
  return (
    <TimeSlotSectionStyled>
      {/* <div className="dayParts">
        <div className="dayPart">Rano</div>
        <div className="dayPart">Południe</div>
        <div className="dayPart">Wieczór</div>
      </div> */}

      <div className="timeSlots">
        {renderTimeSlotsColumn(0, 25)}
        {/* {renderTimeSlotsColumn(12, 18)}
        {renderTimeSlotsColumn(18, 24)} */}
      </div>
    </TimeSlotSectionStyled>
  )
}

const VenueSection = ({ reservation, venue }) => {
  return (
    <VenueSectionStyled>
      <div className="icon">
        <FontAwesomeIcon icon={faHouseUser} />
      </div>
      <div className="name">{venue?.name}</div>
      <div className="product">
        {reservation?.product
          ? reservation.product.name
          : "Nie wybrano scenariusza"}
        <span> {" [+ opcja zmiany scenariusza]"} </span>
      </div>
    </VenueSectionStyled>
  )
}

export const NewReservationBuilder = ({
  venue,
  onSelectTimeSlot,
  onProductSelected,
}) => {
  const reservationContext = useReservationContext()
  const { reservation } = reservationContext
  const { availableSlots, loading } = useVenueAvailableSlots(venue.id)
  const [selectedTimeSlot, setSelectedTimeSlot] = React.useState(undefined)
  const [weeksData, setWeeksData] = React.useState([])
  const [isSaving, setIsSaving] = React.useState(false)

  const [selectedDate, setSelectedDate] = React.useState(
    format(new Date(), "yyyy-MM-dd")
  )
  const [selectedMonth, setSelectedMonth] = React.useState(
    format(new Date(), "yyyy-MM")
  )

  React.useEffect(() => {
    var weeks = []
    var weekStart = startOfWeek(startOfMonth(new Date(selectedMonth)), {
      weekStartsOn: 0,
    })

    for (var i = 0; i < 5; i++) {
      weeks.push({
        startDate: weekStart,
      })
      weekStart = addWeeks(weekStart, 1)
    }

    setWeeksData(weeks)
  }, [selectedMonth])

  const handleSelectDate = (date) => {
    setSelectedDate(date)
    setSelectedTimeSlot(undefined)
  }

  const handleSelectDateTime = () => {
    if (selectedDate) {
      //  && selectedTimeSlot) {
      setIsSaving(true)
      onSelectTimeSlot(selectedDate, selectedTimeSlot)
    }
  }

  if (reservation?.product) {
    return (
      <div className="w-full">
        <div className="w-full sm:w-auto mx-auto p-5 bg-gray-100 border border-gray-300 rounded-2xl">
          {/* <VenueSection reservation={reservation} venue={venue} /> */}

          <MonthSelection
            selectedMonth={selectedMonth}
            onMonthSelected={setSelectedMonth}
          />
          <DateSection
            weeksData={weeksData}
            selectedDate={selectedDate}
            onDateSelected={handleSelectDate}
          />
          {/* <TimeSlotsSection
            availableSlots={availableSlots}
            selectedDate={selectedDate}
            selectedTimeSlot={selectedTimeSlot}
            onTimeSlotSelected={setSelectedTimeSlot}
          /> */}
          <FooterSectionStyled>
            {isSaving ? (
              <div className="flex flex-row items-center justify-center w-full">
                <div className="font-medium text-lg mx-2">
                  Szykujemy rezerwację
                </div>
                <LoadingWidget />
              </div>
            ) : (
              <MButton
                label={`Wybierz ${selectedDate} `}
                // Keep it here waiting for bringing back time slots
                // ${
                //   selectedTimeSlot ? selectedTimeSlot.from : ""
                // }
                color="primary"
                fullWidth
                disabled={!selectedDate}
                onClick={handleSelectDateTime}
              />
            )}
          </FooterSectionStyled>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="text-left font-bold my-2">Wybierz produkt</div>
      <VenueSectionProducts
        venue={venue}
        onProductSelected={onProductSelected}
      />
    </div>
  )
}
